// import React from "react";

// export default function TermsSection() {
//   return (
//     <section id="appointment" className="appointment py-5 pb-5">
//       <div className="container position-relative mb-5 py-4">
//         <header className="section-header mb-5">
//           <h3>Order on your terms</h3>
//         </header>
//         <div className="row my-5 py-4">
//           <div
//             className="col-xl-3 col-md-6 d-flex align-items-stretch aos-init aos-animate"
//             data-aos="zoom-in"
//             data-aos-delay="100"
//           >
//             <div className="icon-box">
//               <div className="icon">
//                 <img
//                   src="/images/message.png"
//                   className="mb-3"
//                   width="102"
//                   height="102"
//                   alt="report"
//                 />
//               </div>
//               <h4 className="mb-5">
//                 In the field and need us to run a report?
//               </h4>
//               <p>Just text us the address and we'll get right on it.</p>
//             </div>
//           </div>
//           <div
//             className="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-md-0 aos-init aos-animate"
//             data-aos="zoom-in"
//             data-aos-delay="200"
//           >
//             <div className="icon-box">
//               <div className="icon">
//                 <img
//                   src="/images/mail.png"
//                   width="102"
//                   className="mb-3"
//                   height="102"
//                   alt="report"
//                 />
//               </div>
//               <h4 className="mb-5">
//                 Have multiple addresses you need us to look at?
//               </h4>
//               <p>Send them over in a quick email and we'll get to measuring.</p>
//             </div>
//           </div>
//           <div
//             className="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-xl-0 aos-init aos-animate"
//             data-aos="zoom-in"
//             data-aos-delay="300"
//           >
//             <div className="icon-box">
//               <div className="icon">
//                 <img
//                   src="/images/cell.png"
//                   width="102"
//                   className="mb-3"
//                   height="102"
//                   alt="report"
//                 />
//               </div>
//               <h4 className="mb-5">Prefer to talk to a real person?</h4>
//               <p>We here to take your order and hear about your day.</p>
//             </div>
//           </div>
//           <div
//             className="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-xl-0 aos-init aos-animate"
//             data-aos="zoom-in"
//             data-aos-delay="400"
//           >
//             <div className="icon-box">
//               <div className="icon">
//                 <img
//                   src="/images/website.png"
//                   width="102"
//                   className="mb-3"
//                   height="102"
//                   alt="report"
//                 />
//               </div>
//               <h4 className="mb-5">
//                 Use the website to keep track of your orders?
//               </h4>
//               <p>Log in and submit your order there.</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useScreenSize } from "../Utils";
import { useCustomScreen } from "../Utils";

export default function TermsSection() {
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();

  const devicePixelRatio = window.devicePixelRatio;

  const { isLandscape1024, isPortrait1024, isIpadProPortrait } =
    useCustomScreen();

  const getColProps = () => {
    if (isLandscape1024) {
      return { xs: 6, sm: 6, md: 3 }; // 4 columns
    } else if (isPortrait1024) {
      return { xs: 12, sm: 12, md: 6 }; // 2 columns
    } else {
      return { sm: 12, md: 6, lg: 3 }; // default layout
    }
  };

  const colProps = getColProps();

  return (
    <div
      className="pt-xs-5"
      style={{
        backgroundImage: "url('/images/Picture2.png')",
        backgroundSize: "cover",
        position: "relative",
        height: isSmallScreen ? "100%" : isIpadProPortrait ? "auto" : "100vh",
      }}
    >
      <section
        style={{
          backgroundColor: "#4e585ae6",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "white",
          height: isSmallScreen ? "100%" : isIpadProPortrait ? "auto" : "100vh",
          width: "100%",
          boxSizing: "border-box",
        }}
        className={`py-5 d-flex ${
          isSmallScreen
            ? "flex-column justify-content-center align-items-center"
            : "flex-column justify-content-center align-items-center"
        } p-3`}
      >
        <div className={`${isSmallScreen ? "pb-5" : "pb-5"}`}>
          <header>
            <h1
              style={{
                fontWeight: "bold",
                fontSize: is4kScreen
                  ? "5.3rem"
                  : isXxlScreen
                  ? "2.8rem"
                  : isXlScreen
                  ? "2.6rem"
                  : isIpadProPortrait
                  ? "3rem"
                  : isLargeScreen
                  ? "2.5rem"
                  : isMediumScreen
                  ? "2.4rem"
                  : isSmallScreen
                  ? "2rem"
                  : "",
                paddingTop: isMediumScreen ? "2rem" : "",
              }}
            >
              Order on your Terms
            </h1>
          </header>
        </div>
        <Container className="pb-5">
          <Row className="gap-3 gap-md-0">
            <Col
              sm={12}
              md={6}
              lg={isIpadProPortrait ? 6 : 3}
              className="gap-3"
            >
              <div
                className="border  d-flex flex-column justify-content-evenly align-items-center"
                style={{
                  padding: "1.2rem",
                  minHeight: is4kScreen
                    ? "50vh"
                    : isXxlScreen
                    ? "50vh"
                    : isXlScreen && devicePixelRatio >= 1.5
                    ? "65vh"
                    : isXlScreen
                    ? "62vh"
                    : isIpadProPortrait
                    ? "40vh"
                    : isLargeScreen
                    ? "65vh"
                    : isMediumScreen
                    ? "40vh"
                    : "",
                  maxHeight: is4kScreen
                    ? "60vh"
                    : isXlScreen
                    ? "60vh"
                    : isIpadProPortrait
                    ? "40vh"
                    : isLargeScreen
                    ? "60vh"
                    : "",
                  minWidth: is4kScreen
                    ? "20vw"
                    : isIpadProPortrait
                    ? "40vw"
                    : isLargeScreen
                    ? "20vw"
                    : "",
                  maxWidth: is4kScreen
                    ? "30vw"
                    : isIpadProPortrait
                    ? "45vw"
                    : isLargeScreen
                    ? "20vw"
                    : "",
                }}
              >
                <div className="d-flex justify-content-center  align-items-center">
                  <img
                    src="/images/message.png"
                    className=""
                    style={{
                      width: is4kScreen
                        ? "250px"
                        : isXxlScreen
                        ? ""
                        : isXlScreen
                        ? "150px"
                        : isLargeScreen
                        ? "120px"
                        : isMediumScreen
                        ? "120px"
                        : "102px",
                      height: is4kScreen
                        ? "250px"
                        : isXxlScreen
                        ? ""
                        : isXlScreen
                        ? "150px"
                        : isLargeScreen
                        ? "120px"
                        : isMediumScreen
                        ? "120px"
                        : "102px",
                    }}
                    alt="report"
                  />
                </div>
                <div className="d-flex justify-content-center  align-items-center">
                  <h5
                    className="text-center"
                    style={{
                      fontWeight: "bold",
                      fontSize: is4kScreen
                        ? "2.6rem"
                        : isXxlScreen
                        ? "1.6rem"
                        : isXlScreen
                        ? "1.3rem"
                        : isIpadProPortrait
                        ? "1.8rem"
                        : isLargeScreen
                        ? "1.1rem"
                        : isMediumScreen
                        ? "1.5rem"
                        : isSmallScreen
                        ? ""
                        : "",
                      // marginTop: isLargeScreen ? "1.2rem" : "",
                    }}
                  >
                    In the field and need us to run a report?
                  </h5>
                </div>
                <div className="d-flex justify-content-center  align-items-center">
                  <h6
                    className="text-center"
                    style={{
                      fontSize: is4kScreen
                        ? "2.3rem"
                        : isXxlScreen
                        ? "1.4rem"
                        : isXlScreen
                        ? "1.3rem"
                        : isIpadProPortrait
                        ? "1.6rem"
                        : isLargeScreen
                        ? "1.1rem"
                        : isMediumScreen
                        ? "1.4rem"
                        : isSmallScreen
                        ? ""
                        : "",
                      // paddingTop: isLargeScreen ? "1.4rem" : "",
                    }}
                  >
                    Just text us the address we'll get right on it.
                  </h6>
                </div>
              </div>
            </Col>

            <Col
              sm={12}
              md={6}
              lg={isIpadProPortrait ? 6 : 3}
              className="gap-3"
            >
              <div
                className="border d-flex flex-column justify-content-evenly align-items-center"
                style={{
                  padding: "1.2rem",
                  minHeight: is4kScreen
                    ? "50vh"
                    : isXxlScreen
                    ? "50vh"
                    : isXlScreen && devicePixelRatio >= 1.5
                    ? "65vh"
                    : isXlScreen
                    ? "62vh"
                    : isIpadProPortrait
                    ? "40vh"
                    : isLargeScreen
                    ? "65vh"
                    : isMediumScreen
                    ? "40vh"
                    : "",
                  maxHeight: is4kScreen
                    ? "60vh"
                    : isXlScreen && devicePixelRatio >= 1.5
                    ? "65vh"
                    : isXlScreen
                    ? "60vh"
                    : isIpadProPortrait
                    ? "50vh"
                    : isLargeScreen
                    ? "60vh"
                    : "",
                  minWidth: is4kScreen
                    ? "20vw"
                    : isIpadProPortrait
                    ? "40vw"
                    : isLargeScreen
                    ? "20vw"
                    : "",
                  maxWidth: is4kScreen
                    ? "30vw"
                    : isIpadProPortrait
                    ? "45vw"
                    : isLargeScreen
                    ? "20vw"
                    : "",
                }}
              >
                <div className="d-flex justify-content-center  align-items-center">
                  <img
                    src="/images/mail.png"
                    className=""
                    style={{
                      width: is4kScreen
                        ? "250px"
                        : isXxlScreen
                        ? ""
                        : isXlScreen
                        ? "150px"
                        : isLargeScreen
                        ? "120px"
                        : isMediumScreen
                        ? "120px"
                        : "102px",
                      height: is4kScreen
                        ? "250px"
                        : isXxlScreen
                        ? ""
                        : isXlScreen
                        ? "150px"
                        : isLargeScreen
                        ? "120px"
                        : isMediumScreen
                        ? "120px"
                        : "102px",
                    }}
                    alt="report"
                  />
                </div>
                <div className="d-flex justify-content-center align-items-center">
                  <h5
                    className="text-center"
                    style={{
                      fontWeight: "bold",
                      fontSize: is4kScreen
                        ? "2.6rem"
                        : isXxlScreen
                        ? "1.6rem"
                        : isXlScreen
                        ? "1.3rem"
                        : isIpadProPortrait
                        ? "1.8rem"
                        : isLargeScreen
                        ? "1.1rem"
                        : isMediumScreen
                        ? "1.5rem"
                        : isSmallScreen
                        ? ""
                        : "",
                      // paddingTop:
                      //   window.innerWidth >= 2500
                      //     ? ""
                      //     : is4kScreen
                      //     ? ""
                      //     : isXlScreen
                      //     ? "3.3rem"
                      //     : isXlScreen && devicePixelRatio >= 1.5
                      //     ? "1.3rem"
                      //     : isXxlScreen && devicePixelRatio === 1
                      //     ? ""
                      //     : isXxlScreen
                      //     ? "3.5rem"
                      //     : isLargeScreen
                      //     ? "2rem"
                      //     : isMediumScreen
                      //     ? ""
                      //     : "",
                    }}
                  >
                    Have multiple addresses you need us to look at?
                  </h5>
                </div>
                <div className="d-flex justify-content-center align-items-center">
                  <h6
                    className="text-center"
                    style={{
                      fontSize: is4kScreen
                        ? "2.3rem"
                        : isXxlScreen
                        ? "1.4rem"
                        : isXlScreen
                        ? "1.1rem"
                        : isIpadProPortrait
                        ? "1.6rem"
                        : isLargeScreen
                        ? "1.1rem"
                        : isMediumScreen
                        ? "1.4rem"
                        : isSmallScreen
                        ? ""
                        : "",
                      // paddingTop: is4kScreen
                      //   ? ""
                      //   : isXlScreen && devicePixelRatio >= 1.5
                      //   ? ""
                      //   : "",
                      // paddingBottom: devicePixelRatio === 1.5 ? "1rem" : "",
                    }}
                  >
                    Send them over a quick email and we'll get to measuring.
                  </h6>
                </div>
              </div>
            </Col>

            <Col
              sm={12}
              md={6}
              lg={isIpadProPortrait ? 6 : 3}
              className=""
              style={{ marginTop: isMediumScreen ? "2rem" : "" }}
            >
              <div
                className={`border d-flex flex-column justify-content-evenly align-items-center mt-${
                  isIpadProPortrait ? "4" : ""
                }`}
                style={{
                  padding: "1.2rem",
                  minHeight: is4kScreen
                    ? "50vh"
                    : isXxlScreen
                    ? "50vh"
                    : isXlScreen && devicePixelRatio >= 1.5
                    ? "65vh"
                    : isXlScreen
                    ? "62vh"
                    : isIpadProPortrait
                    ? "40vh"
                    : isLargeScreen
                    ? "65vh"
                    : isMediumScreen
                    ? "40vh"
                    : "",
                  maxHeight: is4kScreen
                    ? "60vh"
                    : isXlScreen
                    ? "60vh"
                    : isIpadProPortrait
                    ? "50vh"
                    : isLargeScreen
                    ? "60vh"
                    : "",
                  minWidth: is4kScreen
                    ? "20vw"
                    : isIpadProPortrait
                    ? "40vw"
                    : isLargeScreen
                    ? "20vw"
                    : "",
                  maxWidth: is4kScreen
                    ? "30vw"
                    : isIpadProPortrait
                    ? "45vw"
                    : isLargeScreen
                    ? "20vw"
                    : "",
                }}
              >
                <div className="d-flex justify-content-center align-items-center">
                  <img
                    src="/images/cell.png"
                    className=""
                    style={{
                      width: is4kScreen
                        ? "250px"
                        : isXxlScreen
                        ? ""
                        : isXlScreen
                        ? "150px"
                        : isLargeScreen
                        ? "120px"
                        : isMediumScreen
                        ? "120px"
                        : "102px",
                      height: is4kScreen
                        ? "250px"
                        : isXxlScreen
                        ? ""
                        : isXlScreen
                        ? "150px"
                        : isLargeScreen
                        ? "120px"
                        : isMediumScreen
                        ? "120px"
                        : "102px",
                    }}
                    alt="report"
                  />
                </div>
                <div className="d-flex justify-content-center align-items-center">
                  <h5
                    className="text-center"
                    style={{
                      fontWeight: "bold",
                      fontSize: is4kScreen
                        ? "2.6rem"
                        : isXxlScreen
                        ? "1.6rem"
                        : isXlScreen
                        ? "1.3rem"
                        : isIpadProPortrait
                        ? "1.8rem"
                        : isLargeScreen
                        ? "1.1rem"
                        : isMediumScreen
                        ? "1.5rem"
                        : isSmallScreen
                        ? ""
                        : "",
                      paddingTop: is4kScreen
                        ? "1rem"
                        : isXxlScreen
                        ? "1rem"
                        : "",
                      // paddingTop:
                      //   window.innerWidth >= 2500
                      //     ? ""
                      //     : is4kScreen
                      //     ? ""
                      //     : isXlScreen && devicePixelRatio >= 1.5
                      //     ? "1rem"
                      //     : isXxlScreen && devicePixelRatio === 1
                      //     ? ""
                      //     : isXxlScreen
                      //     ? "3rem"
                      //     : isLargeScreen
                      //     ? "2.5rem"
                      //     : "",
                    }}
                  >
                    Prefer to talk to a real person?{" "}
                  </h5>
                </div>
                <div className="d-flex justify-content-center align-items-center">
                  <h6
                    className="text-center"
                    style={{
                      fontSize: is4kScreen
                        ? "2.3rem"
                        : isXxlScreen
                        ? "1.5rem"
                        : isXlScreen
                        ? "1.1rem"
                        : isIpadProPortrait
                        ? "1.6rem"
                        : isLargeScreen
                        ? "1.1rem"
                        : isMediumScreen
                        ? "1.4rem"
                        : isSmallScreen
                        ? ""
                        : "",
                      // paddingTop: is4kScreen
                      //   ? ""
                      //   : isXlScreen && devicePixelRatio >= 1.5
                      //   ? "1.5rem"
                      //   : isLargeScreen
                      //   ? "3rem"
                      //   : "",
                    }}
                  >
                    We here to take your order and hear about your day.{" "}
                  </h6>
                </div>
              </div>
            </Col>

            <Col
              sm={12}
              md={6}
              lg={isIpadProPortrait ? 6 : 3}
              className="gap-3"
              style={{ marginTop: isMediumScreen ? "2rem" : "" }}
            >
              <div
                className={`border d-flex flex-column justify-content-evenly align-items-center mt-${
                  isIpadProPortrait ? "4" : ""
                }`}
                style={{
                  padding: "1.2rem",
                  minHeight: is4kScreen
                    ? "50vh"
                    : isXxlScreen
                    ? "50vh"
                    : isXlScreen && devicePixelRatio >= 1.5
                    ? "65vh"
                    : isXlScreen
                    ? "62vh"
                    : isIpadProPortrait
                    ? "40vh"
                    : isLargeScreen
                    ? "65vh"
                    : isMediumScreen
                    ? "40vh"
                    : "",
                  maxHeight: is4kScreen
                    ? "60vh"
                    : isXlScreen
                    ? "60vh"
                    : isIpadProPortrait
                    ? "50vh"
                    : isLargeScreen
                    ? "60vh"
                    : "",
                  minWidth: is4kScreen
                    ? "20vw"
                    : isIpadProPortrait
                    ? "40vw"
                    : isLargeScreen
                    ? "20vw"
                    : "",
                  maxWidth: is4kScreen
                    ? "30vw"
                    : isIpadProPortrait
                    ? "45vw"
                    : isLargeScreen
                    ? "20vw"
                    : "",
                }}
              >
                <div className="d-flex justify-content-center align-items-center">
                  <img
                    src="/images/website.png"
                    className=""
                    style={{
                      width: is4kScreen
                        ? "250px"
                        : isXxlScreen
                        ? ""
                        : isXlScreen
                        ? "150px"
                        : isLargeScreen
                        ? "120px"
                        : isMediumScreen
                        ? "120px"
                        : "102px",
                      height: is4kScreen
                        ? "250px"
                        : isXxlScreen
                        ? ""
                        : isXlScreen
                        ? "150px"
                        : isLargeScreen
                        ? "120px"
                        : isMediumScreen
                        ? "120px"
                        : "102px",
                    }}
                    alt="report"
                  />
                </div>
                <div className="d-flex justify-content-center align-items-center">
                  <h5
                    className="text-center"
                    style={{
                      fontWeight: "bold",
                      fontSize: is4kScreen
                        ? "2.6rem"
                        : isXxlScreen
                        ? "1.6rem"
                        : isXlScreen
                        ? "1.3rem"
                        : isIpadProPortrait
                        ? "1.8rem"
                        : isLargeScreen
                        ? "1.1rem"
                        : isMediumScreen
                        ? "1.5rem"
                        : isSmallScreen
                        ? ""
                        : "",
                      paddingTop: is4kScreen ? "1rem" : "",
                      // paddingTop: is4kScreen
                      //   ? "4.3rem"
                      //   : isXxlScreen && devicePixelRatio === 1
                      //   ? " "
                      //   : isXxlScreen
                      //   ? "2.2rem"
                      //   : isXlScreen && devicePixelRatio >= 1.5
                      //   ? "1.1rem"
                      //   : "",
                    }}
                  >
                    Use the website to keep track of your orders?{" "}
                  </h5>
                </div>
                <div className="d-flex justify-content-center align-items-center">
                  <h6
                    className="text-center"
                    style={{
                      fontSize: is4kScreen
                        ? "2.6rem"
                        : isXxlScreen
                        ? "1.4rem"
                        : isXlScreen
                        ? "1.1rem"
                        : isIpadProPortrait
                        ? "1.6rem"
                        : isLargeScreen
                        ? "1.1rem"
                        : isMediumScreen
                        ? "1.4rem"
                        : isSmallScreen
                        ? ""
                        : "",
                      // paddingTop: is4kScreen
                      //   ? "2rem"
                      //   : isXlScreen && devicePixelRatio >= 1.5
                      //   ? ""
                      //   : "",
                    }}
                  >
                    Log in and submit your order there.{" "}
                  </h6>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}
